<template>
  <NavBar />
  <main class="practice-page">
    <div class="container practice-container">
      <header class="practice-header">
        <span class="eyebrow">HER GÜN BİR ADIM İLERİ</span>
        <h1>Egzersizler</h1>
        <p>Öğrendiklerini pratiğe dönüştür.<br class="desktop-break"> Bugün nasıl çalışmak istersin?</p>
      </header>

      <section aria-labelledby="practice-title">
        <div class="section-heading">
          <h2 id="practice-title">Pratiğini seç</h2>
          <span>Kendi hızında, kendi yolunda</span>
        </div>
        <div class="practice-grid">
          <router-link v-for="activity in activities" :key="activity.route" :to="{ name: activity.route }" class="practice-card" :class="activity.theme">
            <span class="card-top">
              <span class="activity-icon"><i :class="['bi', activity.icon]" aria-hidden="true"></i></span>
              <span class="activity-label">{{ activity.label }}</span>
            </span>
            <img class="activity-art" :src="activityImages[activity.route]" alt="" width="480" height="280" loading="lazy" decoding="async">
            <h3>{{ activity.title }}</h3>
            <p>{{ activity.description }}</p>
            <span class="card-action">{{ activity.action }}<span class="action-arrow"><i class="bi bi-arrow-right" aria-hidden="true"></i></span></span>
          </router-link>
        </div>
      </section>

      <aside class="practice-tip">
        <span class="tip-icon"><i class="bi bi-lightbulb" aria-hidden="true"></i></span>
        <div><h2>Küçük adımlar, düzenli pratik</h2><p>Her gün kendine biraz zaman ayır. Bir metin oku, bir test çöz ya da yeni bir soruya sesli cevap ver.</p></div>
      </aside>
    </div>
  </main>
  <FooterInPage />
</template>

<script>
import NavBar from '@/components/Shared/NavBar.vue';
import FooterInPage from '@/components/Shared/FooterInPage.vue';
import readingImage from '@/assets/images/excercises/overview/reading-listening.svg';
import testImage from '@/assets/images/excercises/overview/tests.svg';
import conversationImage from '@/assets/images/excercises/overview/random-questions.svg';

export default {
  name: 'ExercisesHome',
  components: { NavBar, FooterInPage },
  data() {
    return {
      activityImages: { ReadingListening: readingImage, Test: testImage, RandomQuestion: conversationImage },
      activities: [
        { route: 'ReadingListening', theme: 'reading', icon: 'bi-headphones', label: 'ANLA & KEŞFET', title: 'Okuma ve Dinleme', description: 'Günlük hayattan konularla metinleri keşfet, dinleyerek anlama becerini geliştir.', action: 'Egzersizleri keşfet' },
        { route: 'Test', theme: 'tests', icon: 'bi-ui-checks', label: 'ÇÖZ & PEKİŞTİR', title: 'Testler', description: 'Bilgilerini sorularla pekiştir, öğrendiklerini test ederek kendini değerlendir.', action: 'Testlere göz at' },
        { route: 'RandomQuestion', theme: 'questions', icon: 'bi-shuffle', label: 'DÜŞÜN & KONUŞ', title: 'Rastgele Soru Oluşturucu', description: 'Yeni bir soruyla düşünmeye başla, kendi cevabını oluştur ve İngilizceni kullan.', action: 'Bir soru oluştur' },
      ],
    };
  },
};
</script>

<style scoped>
.practice-page { min-height: 72vh; padding: 60px 0 64px; background: #f7f9f7; color: #24382e; }
.practice-container { max-width: 1120px; }
.practice-header { margin-bottom: 44px; }
.eyebrow { display: block; margin-bottom: 14px; color: var(--brand-link); font-size: .72rem; font-weight: 700; letter-spacing: .12em; }
.practice-header h1 { margin: 0 0 16px; font-size: clamp(2.2rem, 5vw, 3.2rem); font-weight: 700; letter-spacing: -.045em; }
.practice-header p { margin: 0; color: #637269; font-size: 1.05rem; line-height: 1.8; }
.section-heading { display: flex; justify-content: space-between; align-items: baseline; gap: 16px; margin-bottom: 18px; }
.section-heading h2 { margin: 0; font-size: 1.1rem; font-weight: 600; }
.section-heading > span { color: #637269; font-size: .8rem; }
.practice-grid { display: grid; grid-template-columns: repeat(3, minmax(0, 1fr)); gap: 20px; }
.practice-card { --accent: var(--brand-link); --tint: #edf5eb; display: flex; flex-direction: column; min-width: 0; padding: 28px; border: 1px solid #e2e9e3; border-radius: 22px; background: #fff; color: #24382e; text-decoration: none; box-shadow: 0 6px 24px rgb(36 56 46 / 3%); transition: transform .2s, box-shadow .2s, border-color .2s; }
.activity-art { display: block; width: 100%; height: 160px; object-fit: contain; margin: 8px 0 20px; }
.practice-card.tests { --accent: var(--brand-coral-text); --tint: var(--brand-coral-soft); }
.practice-card.questions { --accent: var(--brand-yellow-text); --tint: var(--brand-yellow-soft); }
.practice-card:hover { transform: translateY(-5px); border-color: var(--accent); color: #24382e; box-shadow: 0 14px 32px rgb(36 56 46 / 8%); }
.practice-card:focus-visible { outline: 3px solid var(--accent); outline-offset: 5px; }
.card-top { display: flex; align-items: center; justify-content: space-between; gap: 12px; margin-bottom: 28px; }
.activity-icon { display: grid; place-items: center; flex-shrink: 0; width: 62px; height: 62px; border-radius: 18px; background: var(--tint); color: var(--accent); font-size: 28px; }
.activity-label { color: var(--accent); font-size: .63rem; font-weight: 700; letter-spacing: .07em; }
.practice-card h3 { margin: 0 0 12px; font-size: 1.35rem; font-weight: 700; letter-spacing: -.025em; line-height: 1.4; }
.practice-card p { margin: 0 0 28px; color: #637269; font-size: .9rem; line-height: 1.85; }
.card-action { display: flex; align-items: center; justify-content: space-between; gap: 12px; margin-top: auto; padding-top: 20px; border-top: 1px solid #edf0ed; color: var(--accent); font-size: .85rem; font-weight: 600; }
.action-arrow { display: grid; place-items: center; width: 34px; height: 34px; flex-shrink: 0; border-radius: 50%; background: var(--tint); }
.practice-tip { display: flex; align-items: center; gap: 16px; margin-top: 28px; padding: 22px 26px; border: 1px solid #e2e9e3; border-radius: 16px; background: #f0f5ef; }
.tip-icon { color: var(--brand-link); font-size: 24px; }
.practice-tip h2 { margin: 0 0 5px; font-size: .9rem; font-weight: 600; }
.practice-tip p { margin: 0; color: #637269; font-size: .82rem; line-height: 1.8; }
@media (max-width: 991.98px) {
  .practice-grid { gap: 14px; }
  .practice-card { padding: 22px; }
  .card-top { align-items: flex-start; flex-direction: column; gap: 14px; }
}
@media (max-width: 767.98px) {
  .practice-page { padding: 36px 0 40px; }
  .practice-header { margin-bottom: 32px; }
  .desktop-break { display: none; }
  .section-heading { align-items: flex-start; flex-direction: column; gap: 6px; }
  .practice-grid { grid-template-columns: 1fr; }
  .card-top { align-items: center; flex-direction: row; margin-bottom: 20px; }
  .practice-card p { margin-bottom: 20px; }
  .practice-tip { align-items: flex-start; padding: 20px; }
}
@media (prefers-reduced-motion: reduce) {
  .practice-card { transition: none; }
  .practice-card:hover { transform: none; }
}
</style>
